import { type FragmentType, useFragment } from '@/gql/codegen';
import { graphql } from '@/gql/codegen/gql';
import { Button } from '@/routes/_embaUserLayout/-components/Button';
import classNames from 'classnames';
import type React from 'react';
import { Character } from '../../Character';
import { Dialog } from '../../Dialog';
import styles from './index.module.scss';

export const COURSE_LESSON_SCENARIO_STORY_CHOICE_FRAGMENT =
  graphql(/* GraphQL */ `
  fragment EmbaCourseLessonScenarioStoryChoice on ScenarioContentChoice {
    ...on ScenarioContentChoice {
      dialog
      name
      character
      choices {
        slug
        text
        nextId
      }
    }
  }
`);

type ChoiceProps = {
  currentStoryContent: FragmentType<
    typeof COURSE_LESSON_SCENARIO_STORY_CHOICE_FRAGMENT
  >;
  isEnableNext: boolean;
  animationComplete: () => void;
  typingSpeed: number;
  showBlinkingArrow: boolean;
  slideToNext: () => void;
  embaUserlastName: string;
  showInteractions: boolean;
  setCurrentStoryId: (index: number) => void;
  setShowInteractions: (value: boolean) => void;
};

export const Choice: React.FC<ChoiceProps> = ({
  currentStoryContent,
  isEnableNext,
  animationComplete,
  typingSpeed,
  showBlinkingArrow,
  slideToNext,
  embaUserlastName,
  showInteractions,
  setCurrentStoryId,
  setShowInteractions,
}) => {
  const currentStoryContentData = useFragment(
    COURSE_LESSON_SCENARIO_STORY_CHOICE_FRAGMENT,
    currentStoryContent,
  );

  return (
    <>
      <Character character={currentStoryContentData.character} />
      <div className={styles.contentArea}>
        <div
          className={classNames(styles.interactions, {
            [styles.display]: showInteractions,
          })}
        >
          <div className={styles.choices}>
            {currentStoryContentData.choices.map((choice) => (
              <Button
                key={choice.slug}
                onClick={() => {
                  setCurrentStoryId(choice.nextId);
                  setShowInteractions(false);
                }}
              >
                {choice.text}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <Dialog
        dialog={currentStoryContentData.dialog}
        name={currentStoryContentData.name}
        embaUserlastName={embaUserlastName}
        isEnableNext={isEnableNext}
        slideToNext={slideToNext}
        animationComplete={animationComplete}
        typingSpeed={typingSpeed}
        showBlinkingArrow={showBlinkingArrow}
      />
    </>
  );
};
